import {
  getPropertyDocumentsEndpoints,
  IUpdatePropertyDocumentStatusDTO,
  IUploadPropertyFilesDTO,
  TDeletePropertyFileDTO,
  TGetLegalDocumentsResponse,
  TGetLegalDocumentsDTO,
  TGetPropertyDocumentsDTO,
  TGetPropertyDocumentsResponse,
  TGetPropertyFilesDTO,
  TGetPropertyFilesResponse,
  TGetSelfDeclarationDTO,
  TGetSelfDeclarationResponse,
} from '@/models/documents.model';
import { ApiResponse, httpClient } from '@/utils';

class DocumentsAPI {
  static getPropertyDocuments({ propertyId }: TGetPropertyDocumentsDTO): ApiResponse<TGetPropertyDocumentsResponse> {
    const { PROPERTY_DOCUMENTS } = getPropertyDocumentsEndpoints({ propertyId });
    return httpClient.get<TGetPropertyDocumentsResponse>(PROPERTY_DOCUMENTS);
  }

  static updatePropertyDocumentStatus({
    propertyId,
    documentId,
    is_checked,
  }: IUpdatePropertyDocumentStatusDTO): ApiResponse<TGetPropertyDocumentsResponse> {
    const { PROPERTY_DOCUMENT } = getPropertyDocumentsEndpoints({ propertyId, documentId });
    return httpClient.post<TGetPropertyDocumentsResponse>(PROPERTY_DOCUMENT, { is_checked });
  }

  static getPropertyFiles({ propertyId }: TGetPropertyFilesDTO): ApiResponse<TGetPropertyFilesResponse> {
    const { PROPERTY_FILES } = getPropertyDocumentsEndpoints({ propertyId });

    return httpClient.get<TGetPropertyFilesResponse>(PROPERTY_FILES);
  }

  static getLegalDocuments({ propertyId }: TGetLegalDocumentsDTO): ApiResponse<TGetLegalDocumentsResponse> {
    const { LEGAL_DOCUMENTS } = getPropertyDocumentsEndpoints({ propertyId });

    return httpClient.get<TGetLegalDocumentsResponse>(LEGAL_DOCUMENTS);
  }

  static getSelfDeclaration({ propertyId }: TGetSelfDeclarationDTO): ApiResponse<TGetSelfDeclarationResponse> {
    const { SELF_DECLARATION } = getPropertyDocumentsEndpoints({ propertyId });

    return httpClient.get<TGetSelfDeclarationResponse>(SELF_DECLARATION);
  }

  static deletePropertyFiles(data: TDeletePropertyFileDTO): ApiResponse<TGetPropertyFilesResponse> {
    const { propertyId, fileId } = data;
    const { PROPERTY_FILE } = getPropertyDocumentsEndpoints({ propertyId, fileId });

    return httpClient.delete<TGetPropertyFilesResponse>(PROPERTY_FILE);
  }

  static uploadPropertyFiles({ propertyId, ...data }: IUploadPropertyFilesDTO): ApiResponse<TGetPropertyFilesResponse> {
    const { PROPERTY_FILES } = getPropertyDocumentsEndpoints({ propertyId });

    return httpClient.put<TGetPropertyFilesResponse>(PROPERTY_FILES, data);
  }
}

export default DocumentsAPI;
